<template>
  <div class="warp">
    <ul class="ul">
      <li v-for="item in expression" :key="item.id">
        <div class="li-box">
          <div class="li-box-title">{{item.displayName}}</div>
          <div class="li-box-value">{{item.value}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import api from "../../../../../common/api/index";
import socket from "@/utils/websocket.js"; // 组件
export default {
  props: ['measureId'],
  data () {
    return {
      // 所有的采集项
      expression: {},
      webSock: {},
      socket: null
    }
  },
  watch: {
    measureId (newVal, oldVal) {
      this.init(newVal);
    }
  },
  methods: {
    init (measureId) {
      let vm = this;

      api.measuringServer.allotMeasuringRealtimeNotifyServer().then((res) => {
        vm.webSock.ip = res.data.ip;
        vm.webSock.port = res.data.port;
        vm.webSock.key = res.data.key;
        vm.webSock.path = res.data.path;
        if (measureId) {
          vm.getExpression()
        }
      });
    },
    getExpression () {
      let vm = this
      api.measure.getUniqueMeasuresExpressions(JSON.stringify([vm.measureId])).then(res => {
        let expression = {}
        if (res && res.data) {
          for (let i = 0; i < res.data[0].expressionGroups.length; i++) {
            const group = res.data[0].expressionGroups[i];
            for (let j = 0; j < group.expression.length; j++) {
              let item = group.expression[j];
              item.value = '-'
              // code+num设置key
              expression[vm.getKey(item.pointCode, item.pointNumber)] = item
            }
          }
          vm.expression = expression
          // 开启ws  或者关掉上一个链接
          vm.initWebSock()
        }
      })
    },
    initWebSock () {
      let vm = this
      let agentData = {
        methodCode: "101",
        key: vm.webSock.key,
      }
      if (vm.socket) {
        vm.socket.close()
        vm.socket = null
      }
      vm.socket = new socket({
        //网址（端口是我下面的服务器的端口）
        url:
          window.baseConfig.wsAgreement + "://" + vm.webSock.ip + ":" + vm.webSock.port + "/" + vm.webSock.path,
      });

      vm.socket.onopen((event) => {
        vm.socket.send(agentData);
      });
      //接收信息
      vm.socket.onmessage((data) => {
        vm.webSockMsg(JSON.parse(data));
      });
    },
    webSockMsg (e) {
      let vm = this;
      if (e.methodCode == "102") {
        //注册计量点  103
        let points = []
        for (const key in vm.expression) {
          const item = vm.expression[key]
          points.push({ code: item.pointCode, number: item.pointNumber })
        }
        let agentData = {
          methodCode: "103",
          measures: [{ id: vm.measureId, points: points }],
        };
        vm.socket.send(agentData);
      }
      else if (e.methodCode === '105') {
        for (let k = 0; k < e.data.length; k++) {
          for (let i = 0; i < e.data[k].data.length; i++) {
            const item = e.data[k].data[i]
            // 开关
            if (item.pointCode === 601) {
              vm.expression[vm.getKey(item.pointCode, item.pointNumber)].value = item.value === 0 ? '打开' : '关闭'
            } else {
              vm.expression[vm.getKey(item.pointCode, item.pointNumber)].value = Number(item.value).toFixed(2)
            }
          }
        }
      }
    },
    getKey (code, number) {
      return code + '_' + number
    }

  }
}
</script>

<style lang="scss" scoped>
.warp {
  margin-bottom: -10px;
}
.ul {
  list-style: none;
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  padding: 0px;
  li {
    float: left;
    width: 170px;
    .li-box {
      display: flex;
      flex-flow: column;
      text-align: center;
      background: linear-gradient(180deg, #e8f8ff 0%, #cceeff 100%);
      margin: 0px 10px auto;
      margin-bottom: 10px;
      border-radius: 4px;
      padding: 6px 0px;

      .li-box-value {
        font-size: 18px;
        line-height: 32px;
      }
    }
  }
}
</style>